<template>
  <v-container fluid>
    <V-row>
      <v-col md="12">
        <SettingItem
          @loadData="loadData"
          collection="counteries"
          :items="counteries"
          :itemHeader="counteriesItemHeader"
        />
      </v-col>
    </V-row>
  </v-container>
</template>

<script>
import SettingItem from "./SettingItem/index";
import ApiService from "@/services/api.service";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SettingItem,
  },
  data() {
    return {
      counteries: [],
      counteriesItemHeader: [
        { text: "Title", value: "arabic_title" },
        { text: "iso code", value: "iso_code" },
        { text: "dialing code", value: "dialing_code" },
        { text: "currency", value: "currency_id.title" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        this.fetchData();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        const data = await ApiService.get(
          "items/counteries?fields=id,arabic_title,english_title,iso_code,dialing_code,currency_id.id,currency_id.title"
        );
        this.counteries = data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchData(undefined);
  },
};
</script>

<style></style>
